import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'react-flexr/styles.css';
import './common/styles/app.less';
import './common/styles/stilr.css';

// Disabled until apm-server@6.2 is released
// import './apm';

import React from 'react';
import ReactDOM from 'react-dom';
import createStore from './redux/create';
import reducer from './redux/modules/reducer';
import ApiClient from './helpers/ApiClient';
// import * as clicky from './utils/clicky';
import App from './provider';
import { Provider as ReduxProvider } from 'react-redux';

window.addEventListener(
  'CookieInformationConsentGiven',
  function(event) {
    // if (
    //   window.CookieInformation.getConsentGivenFor('cookie_cat_unclassified')
    // ) {
    // }
    // if (window.CookieInformation.getConsentGivenFor('cookie_cat_necessary')) {
    // }
    // if (
    //   window.CookieInformation.getConsentGivenFor('cookie_cat_functional')
    // ) {
    // }
    // if (window.CookieInformation.getConsentGivenFor('cookie_cat_statistic')) {
    //   clicky.initialise();
    // }
    // if (window.CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
    // }
  },
  false
);

if (__DEV__) {
  global.React = React; // enable debugger

  require('immutable-devtools')(require('immutable'));
}

function getInitialState() {
  if (__CLIENT__) {
    try {
      return document.getElementById('state').textContent || null;
    } catch (err) {
      return null;
    }
  } else {
    return null;
  }
}

const store = createStore({
  reducer,
  client: new ApiClient(),
  data: getInitialState() || {}
});

const dest = document.getElementById('content');
ReactDOM.hydrate(
  <ReduxProvider store={store}>
    <App />
  </ReduxProvider>,
  // provider({ store }),
  dest
);
